export const defaultConfiguration = {
    closedStyle: 'chat',
    introMessage: 'お問い合わせ内容を入力してください',
    placeholderText: '質問を入力',
    textButton: '質問する',
    mainColor: '#1f8ceb',
    alwaysUseFloatingButton: true,
    desktopHeight: 450,
    desktopWidth: 370,
    titleChat: "AI CHAT AGENT",
    avatar: "/media/ai-icon.png",
    positionDisplayIconChat: "right",
    openPopupChat: false,
    apiMode: 1
};



// WEBPACK FOOTER //
// ./src/widget/default-configuration.js